<template>
  <div>
    <van-popup
      v-model="show"
      position="center"
      round
      class="my-popup"
      @close="bindClose"
    >
      <div class="toast-container">
        <img
          class="image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/211f0ae4da91f8bcf0f18617b1795d06.png"
          alt=""
        />
        <div class="consult" @click="bindConfirm"></div>
        <div class="close iconfont icon-cha" @click="bindCancel"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    voteNum: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      show: false,
      curVoteNum: 1
    }
  },
  watch: {
    value() {
      this.show = this.value
      this.curVoteNum = 1
    }
  },
  created() {
    this.show = this.value
  },
  methods: {
    bindClose() {
      this.$emit('input', false)
    },
    bindCancel() {
      this.$emit('input', false)
    },
    bindConfirm() {
      let url =
        'pages/image-page/index?url=' +
        encodeURIComponent(
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a968659dfb6802fe276683f3361dee71.png'
        )
      this.$betterwe.jumpMiniProgram({ path: url })
      this.$emit('input', false)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .van-popup {
  overflow-y: visible;
  background-color: transparent;
}
.toast-container {
  position: relative;
  width: 295px;
  height: 229px;
  .image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .consult {
    position: absolute;
    left: 50%;
    bottom: 20px;
    transform: translate(-50%, 0%);
    width: 255px;
    height: 44px;
  }
  .close {
    position: absolute;
    left: 50%;
    bottom: -40px;
    transform: translate(-50%, 0%);
    width: 24px;
    height: 24px;
    border: 1px solid #fff;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
